export const QUICK_ANSWERS_MESSAGE_IDS = {
  user: "ai-message-user-quick-answer",
  assistant: "ai-message-assistant-quick-answer",
};
